import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Card, Col, Container, Row } from "reactstrap";
import AuthSlider from "./authCarousel";

const ConfirmEmail = () => {
    const { status } = useParams();

    useEffect(() => {
        document.title = "Confirmação de Email | Plantão Rápido";
    }, []);

    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>

                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider />
                                        <Col lg={6}>
                                            <div className="account-info p-4 p-md-5">
                                                <div className="login-back mb-4">
                                                    <Link to="/" className="text-decoration-none">
                                                        <i className="fa-solid fa-arrow-left-long me-2"/> Home
                                                    </Link>
                                                </div>

                                                <h5 className="text-primary">Acesso Inicial Validar E-mail</h5>
                                                <p className="text-muted">
                                                    Seu e-mail será validado através do link enviado.
                                                </p>

                                                <div className="login-success-icon text-center my-4">
                                                    {status === "success" ? (
                                                        <i className="fas fa-circle-check fa-3x"
                                                           style={{color: "green"}}/>
                                                    ) : (
                                                        <i className="fas fa-circle-exclamation fa-3x"
                                                           style={{color: "red"}}/>
                                                    )}
                                                </div>

                                                <div className="login-title text-center">
                                                    <h3>Confirmação de Email</h3>
                                                    <p className="mb-0">
                                                        {status === "success"
                                                            ? "Seu email foi confirmado com sucesso."
                                                            : "Houve um erro ao confirmar seu email."}
                                                    </p>
                                                </div>

                                                <div className="form-group mt-4">
                                                    <Link
                                                        className="btn btn-primary w-100"
                                                        to="/admin/login"
                                                        target="_blank"
                                                    >
                                                        Login
                                                    </Link>
                                                </div>
                                                <div className="form-group mt-2">
                                                    <a className="btn btn-light w-100"
                                                       href="https://www.plantaorapido.com.br/">
                                                        <i className="fa-solid fa-arrow-left me-2"/> Voltar para Home
                                                    </a>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                            <div className="text-center">
                                    <p className="mb-0">
                                        &copy; {new Date().getFullYear()}{" "}
                                        <a
                                            className="text-reset text-decoration-none"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://medr.com.br/"
                                        >
                                            MEDR
                                        </a>
                                        . Todos os direitos reservados.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default ConfirmEmail;
